import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import isEmpty from "lodash/isEmpty";
import sumBy from "lodash/sumBy";

import template from './index.rt';
import {showFingerSignatureSetupOverlay} from "../AddNewEntity/AddNewEntityActions";
import * as Misc from "../../misc";
import {errorBox_Show, setFingerSignaturePopupState} from "../../actions/A_Popups";
import {getActiveContract} from "./contractFunctions";
import {getContracts, uploadAndSaveContracts} from "./contractsAsyncActions";

const mapStateToProps = (store) => {
  const {contractsView, contractsList} = store.contractsState;
  const formValues = (store.form && store.form.newEntity && store.form.newEntity.values) || {};
  return {
    contractsView,
    formValues,
    fabricatorId: formValues.id,
    fabricator: formValues,
    contractsList,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeDialog: () => {
      dispatch(showFingerSignatureSetupOverlay(false));
      dispatch(setFingerSignaturePopupState({
        showPopup: false,
      }));
    },
    errorBox_Show: config => dispatch(errorBox_Show(config)),
    getContracts: (fabricatorId) => dispatch(getContracts(fabricatorId)),
    uploadAndSaveContracts: (fabricatorId) => dispatch(uploadAndSaveContracts(fabricatorId)),
  }
}

export class FingerSignature extends Component {
  state = {
    fields: [],
    documentUrl: null,
    showESignatureOverlay: false,
    termsAccepted: false,
    termsAcceptedEnabled: true
  }

  constructor(props) {
    super(props);

    const {fabricator} = props;
    this.state.termsAccepted = fabricator.fingerSignatureTermsAcceptedAt !== null;
    this.state.termsAcceptedEnabled = !this.state.termsAccepted;
    // this.state.documentUrl = fabricator.fingerSignatureMasterDocumentFullUrl;
  }

  componentDidMount() {
    this.props.getContracts(this.props.fabricatorId);
  }

  componentWillUnmount() {
    this.props.closeDialog(); // clear fabricator form values
  }

  getFieldMark = fieldNames => {
    let names = [];
    if (typeof fieldNames === 'string')
      names.push(fieldNames)
    else
      names = fieldNames;

    const activeContract = getActiveContract(this.props.contractsList);
    if (!activeContract) {
      return (<img className="mark-icon" alt="" src={Misc.hostedImageUrl('images/icon-blank.jpg')}/>);
      // return null
    } else {
      const entries = activeContract.fields.filter(field => {
        return names.some(name => field.isPresent && field.name.toLowerCase() === name.toLowerCase())
      })

      if (isEmpty(entries)) {
        return <img className="mark-icon" alt="" src={Misc.hostedImageUrl('images/icon-x.svg')}/>;
      }

      const count = sumBy(entries, 'occurrencesCount')

      if (count === 1) {
        return <img className="mark-icon" alt="" src={Misc.hostedImageUrl('images/icon-check.svg')}/>;
      }

      return (
        <span className='mark-icon success-title'>
          {count}
        </span>
      );
    }
  }

  handleOnSave = async () => {
    if (!this.state.termsAccepted) {
      this.showError('Terms and Conditions must be accepted.');
      return;
    }
    await this.props.uploadAndSaveContracts(this.props.fabricatorId);
    this.props.formValues.fingerSignatureTermsAcceptedAt = new Date();
    this.props.closeDialog();
  }

  handleOnCancel = e => {
    Misc.ignoreDefault(e);
    this.props.closeDialog();
  }

  handleAcceptTerms = e => {
    Misc.ignoreDefault(e);
    this.setState({termsAccepted: !this.state.termsAccepted});
  }

  handleJotFormSubmitted = () => {
    const scrollElement = document.getElementsByClassName('new-account-content')[0];
    if (scrollElement) {
      scrollElement.classList.remove('noscroll');
    }
    this.setState({
      showESignatureOverlay: false,
      termsAccepted: true,
      termsAcceptedEnabled: false
    });
  }

  showError = text => {
    this.props.errorBox_Show({
      title: 'Error',
      text,
      rightButtonText: 'OK',
      isRightButtonVisible: true
    })
  }

  render = template
}

FingerSignature.propTypes = {
  closeDialog: PropTypes.func.isRequired,
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(FingerSignature);
